export default __webpack_public_path__ + "static/media/reply-received.54e75352.svg";